import React, { useState, useRef } from 'react';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import api from '~/services/api';
// Importando o componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';

import { Container } from './styles';

export default function Cidade() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  // Gerando os dados para os selects
  const capital = [
    {
      value: 1,
      label: 'Sim',
    },
    {
      value: 2,
      label: 'Nao',
    },
  ];

  const estado = [
    {
      value: 'AC',
      label: 'AC',
    },
    {
      value: 'AL',
      label: 'AL',
    },
    {
      value: 'AM',
      label: 'AM',
    },
    {
      value: 'AP',
      label: 'AP',
    },
    {
      value: 'BA',
      label: 'BA',
    },
    {
      value: 'CE',
      label: 'CE',
    },
    {
      value: 'DF',
      label: 'DF',
    },
    {
      value: 'ES',
      label: 'ES',
    },
    {
      value: 'GO',
      label: 'GO',
    },
    {
      value: 'MA',
      label: 'MA',
    },
    {
      value: 'MG',
      label: 'MG',
    },
    {
      value: 'MS',
      label: 'MS',
    },
    {
      value: 'MT',
      label: 'MT',
    },
    {
      value: 'PA',
      label: 'PA',
    },
    {
      value: 'PB',
      label: 'PB',
    },
    {
      value: 'PE',
      label: 'PE',
    },
    {
      value: 'PI',
      label: 'PI',
    },
    {
      value: 'PR',
      label: 'PR',
    },
    {
      value: 'RJ',
      label: 'RJ',
    },
    {
      value: 'RN',
      label: 'RN',
    },
    {
      value: 'RO',
      label: 'RO',
    },
    {
      value: 'RR',
      label: 'RR',
    },
    {
      value: 'RS',
      label: 'RS',
    },
    {
      value: 'SC',
      label: 'SC',
    },
    {
      value: 'SE',
      label: 'SE',
    },
    {
      value: 'SP',
      label: 'SP',
    },
    {
      value: 'TO',
      label: 'TO',
    },
  ];

  /**
   * Funçoes
   */

  async function handleSubmit(data, { reset }) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        uf: Yup.string('Selecione um estado').required('Selecione um estado'),
        capital: Yup.string('Selecione se é capital').required(
          'Selecione se é capital'
        ),
        name: Yup.string().required('Preencha o campo nome'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/cidade', {
        name: data.name.toUpperCase(),
        uf: data.uf,
        capital: data.capital,
      });

      toast.success('Cidade cadastrada com sucesso');
      reset();
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Cidade já foi cadastrada.');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastrar Cidades</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handleSubmit} autoComplete="off">
          <Select name="uf" labelSelect="Estados" options={estado} />
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Select name="capital" labelSelect="Capital" options={capital} />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
